import { Component } from '@angular/core';
import {
  DsButtonModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule,
  DsToastService,
} from '@bmw-ds/components';
import { CrossBorderService } from '../../../services/crossborder.service';
import { UnitSearchHoldRequest, UnitSearchHoldResponse } from '../../../models/unit-search-hold.model';
import { NgIf } from '@angular/common';


@Component({
  selector: 'app-free-allocation-modal',
  templateUrl: './free-allocation-modal.html',
  imports: [DsModalModule, DsButtonModule, NgIf],
  styleUrls: ['../unit-update/unit-update-modal.scss'],
})
export class FreeAllocationModalComponent {
  // This component is currently empty, but you can add properties and methods as needed.
  // For example, you might want to handle form submission or manage state related to free allocation.
  freeAllocationModalIsOpen: boolean = false;
  unitSearchHoldResponse!: UnitSearchHoldResponse;
  unitSearchHoldRequest: UnitSearchHoldRequest= {
    vin: '',
    body_no : '',
    dealer:'',
    userid: '',
    onoroff: ''
  };
  modalData = {
    vin: '',
    bodyNo: '',
    ind: '',
  };
  constructor(
    private crossBorderService: CrossBorderService,
    private loadingAreaService: DsLoadingAreaService,
    private toastService: DsToastService
  ) {}
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: '',
    loadingText: '',
  };

  activateFreeAllocationModal(vin: string, bodyNo: string, indicator: string) {
    this.freeAllocationModalIsOpen = true;
    this.modalData.vin = vin;
    this.modalData.ind = indicator;
    this.modalData.bodyNo = bodyNo;
  }

  closeModal() {
    this.freeAllocationModalIsOpen = false;
  }

  // callFsServlet(vin: string, bodyNo: string) {
  //   this.unitSearchHoldRequestldResponseponse = null;
  //   this.unitSearchHoldRequest = {
  //     vin: vin,
  //     body_no : bodyNo,
  //     dealer:'',
  //
  //   }
  // }

  doFs(vin: string, bodyNo: string, indicator: any) {
    // this.unitSearchHoldRequestldResponseponse = null;
    this.unitSearchHoldRequest.vin = vin;
    this.unitSearchHoldRequest.body_no = bodyNo;
    this.unitSearchHoldRequest.onoroff = (indicator === "X") ? "F" : "N";
    this.unitSearchHoldRequest.dealer = localStorage.getItem('dealerCode') || '';
    this.unitSearchHoldRequest.userid = localStorage.getItem('euserid') || '';

    this.crossBorderService.getUnitSearchAvailableAllocation(this.unitSearchHoldRequest).subscribe({
      next: (response: UnitSearchHoldResponse) => {
        this.unitSearchHoldResponse = response;
        this.toastService.pushToast({
          id: 'free-allocation-success-toast',
          tone: 'neutral',
          toastText: response.message,
        });
        this.closeModal();
      },
      error: (error) => {
        this.toastService.pushToast({
          id: 'free-allocation-error-toast',
          tone: 'critical',
          toastText: 'Free Allocation failed',
        });
        console.error('Error during Free Allocation:', error);
      },
    });
  }
}